import * as actions from "./actionsType";

const initialData = {
  loading: false,
  saveLoading: false,
  planSeguimiento: [],
  planSeguimientoError: "",
  formError: "",
};

export default function PlanSeguimientoReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_PLAN_SEGUIMIENTO:
      return { ...state, loading: action.payload };

    case actions.SAVE_LOADING_PLAN_SEGUIMIENTO:
      return { ...state, saveLoading: action.payload };

    case actions.GET_PLAN_SEGUIMIENTO:
      return {
        ...state,
        planSeguimiento: action.payload.planSeguimiento
      };

    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };

    case actions.PLAN_SEGUIMIENTO_FAIL:
      return { ...state, planSeguimientoError: action.payload };

    default:
      return state;
  }
}
